import { Box, Container } from '@material-ui/core'
import { useParams } from 'react-router-dom'

import { Stepper } from '@/components/stepper'

import { DiagnosisRegistrationStoreProvider } from './contexts/diagnosis-registration-store-context'
import { Finish } from './steps/finish'
import { PhysiologicalRegister } from './steps/physiological-register'
import { PlantingFailureInfo } from './steps/planting-failure-info'
import { Register } from './steps/register'
import { Resume } from './steps/resume'
import { SelectFiles } from './steps/select-files'
import { UploadFiles } from './steps/upload-files'
import { useStyles } from './styles'

const steps = {
  register: { component: () => <Register />, index: 0 },
  'physiological-register': {
    component: () => <PhysiologicalRegister />,
    index: 0,
  },
  'planting-failure-register': {
    component: () => <PlantingFailureInfo />,
    index: 0,
  },
  'select-files': { component: () => <SelectFiles />, index: 1 },
  resume: { component: () => <Resume />, index: 2 },
  'upload-files': { component: () => <UploadFiles />, index: 3 },
  finish: { component: () => <Finish />, index: 4 },
}

const stepsLabel = [
  'Informações básicas',
  'Selecionar diagnóstico',
  'Confirmar diagnóstico',
  'Carregar arquivos',
  'Confirmar cadastro',
]

const Demands = () => {
  const classes = useStyles()

  const { state } = useParams<{ state: keyof typeof steps }>()

  const CurrentComponent = steps[state!]?.component

  if (!CurrentComponent) return null

  return (
    <Box height='100%' minHeight='0' display='flex' flexDirection='column'>
      <Container className={classes.stepperContainer}>
        <Stepper activeStep={steps[state!]?.index} steps={stepsLabel} />
      </Container>
      <DiagnosisRegistrationStoreProvider>
        <CurrentComponent />
      </DiagnosisRegistrationStoreProvider>
    </Box>
  )
}

export default Demands
